// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'about',
          name: 'About',
          component: () => import('@/views/about/Index.vue'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: 'contact-us',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'actu',
          name: 'actu',
          component: () => import('@/views/actu/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'statuts',
          name: 'statuts',
          component: () => import('@/views/statuts/Index.vue'),
          meta: { src: require('@/assets/article-4.jpg') },
        },
        {
          path: 'mission',
          name: 'mission',
          component: () => import('@/views/mission/Index.vue'),
          meta: { src: require('@/assets/article-4.jpg') },
        },

        {
          path: 'mentions-legales',
          name: 'mentions-legales',
          component: () => import('@/views/MentionsLegales/Index.vue'),
          meta: { src: require('@/assets/article-4.jpg') },
        },
        {
          path: 'post',
          name: 'post',
          component: () => import('@/views/post/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'intro',
          name: 'intro',
          component: () => import('@/views/intro/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'soutenir',
          name: 'soutenir',
          component: () => import('@/views/soutenir/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: () => import('@/views/admin/Login.vue'),
    },
    {
      path: '/admin/forms',
      name: 'AdminForms',
      component: () => import('@/views/admin/Forms.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/alerts',
      name: 'AdminAlerts',
      component: () => import('@/views/admin/Alerts.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/communiques',
      name: 'AdminCommuniques',
      component: () => import('@/views/admin/Communiques.vue'),
      meta: { requiresAuth: true },
    },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    }

  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      next({ name: 'AdminLogin' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
